import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { PAYMENT_INTEGRITY_DETAILS_API_URL } from './apiUrlConstants';

const _httpService = new HttpService();

// Set the API base URL based on the environment
 _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));

/**
 * Get payment integrity details data from the API
 * @param payload - The request payload containing filters
 * @returns The API response data
 */
export const getPaymentIntegrityDetailsData = async (payload: any) => {
  try {
    // Make the API call
    const response = await _httpService.push(PAYMENT_INTEGRITY_DETAILS_API_URL, payload);
    
    return response;
  } catch (error) {
    console.error('Error fetching payment integrity details:', error);
    return null;
  }
};
